import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../modules/infra/i18n';

const DeleteButton = ({ onClick, className, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    type="button"
    className={className}
    data-automation-id="button:delete"
  >
    <span className="c-btn__text">{t('common:buttons.delete')}</span>
  </button>
);

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

DeleteButton.defaultProps = {
  className: 'c-btn c-btn--red c-btn--small u-mt-',
  disabled: false,
};

export default DeleteButton;
